import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';
import { validateSubscriptionSettings } from 'model';
import { useUserHasFeatureFlag } from './userHasFeatureFlag.js';

export function useSubscriptionsEnabled(): boolean {
	const { data: siteSettings } = useGetPublicInformationQuery();
	const subscriptionFlag = useUserHasFeatureFlag('subscription');
	return validateSubscriptionSettings(siteSettings) && subscriptionFlag;
}
